<template>
  <div
  :class="[
      { '!bg-opacity-85 !backdrop-blur-md shadow-lg': scrolled && route.name === `index` },
      { '!bg-opacity-0 !backdrop-blur-0': !scrolled && route.name === `index` },
      { 'bg-opacity-100 shadow-lg backdrop-blur-md': route.name !== `index`},
      { '!bg-opacity-85 !backdrop-blur-md shadow-lg': scrolled && route.name !== `index`},
      showNavbar ? 'translate-y-0':'-translate-y-full'
    ]"
    class="transition-all duration-500 bg-white fixed w-full top-0 z-30">
    <nav :class="[
      { 'text-white': !scrolled && route.name === `index` },
      { 'text-ip-color-3': scrolled && route.name === `index` },
      { 'text-ip-color-3': route.name !== `index` }
    ]" class="container-1 text-black flex items-center justify-between py-5 md:py-[3vw] lg:py-[1.3vw] transition-color duration-500">
      <NuxtLink :to="({name: 'index'})">
        <MainLogo class="max-w-[9rem] lg:max-w-[10vw]"/>
      </NuxtLink>

      <div class="hidden lg:flex gap-10">
        <div v-for="(item, i) in navMenus" :key="item.id">
          <NuxtLink v-if="item.type == 'link'" :to="({name: item.path})" class="block figtree relative w-fit overflow-clip group pb-1">
            <span class="whitespace-nowrap figtree font-semibold lg:text-[1vw]">{{ item.name[locale] }}</span>
            <div :class="[
              { 'border-white': !scrolled && route.name === `index` },
              { 'border-ip-color-3': scrolled && route.name === `index` },
              { 'border-ip-color-3': route.name !== `index` }
            ]" class="active-link absolute w-full border-t-2 bottom-0 -translate-x-[102%] group-hover:translate-x-0 transition-transform duration-300"></div>
          </NuxtLink>
          <button v-else @click="item.function()" class="block figtree relative w-fit overflow-clip group pb-1">
            <span class="whitespace-nowrap figtree font-semibold lg:text-[1vw]">{{ item.name[locale] }}</span>
            <div :class="[
              { 'border-white': !scrolled && route.name === `index` },
              { 'border-ip-color-3': scrolled && route.name === `index` },
              { 'border-ip-color-3': route.name !== `index` }
            ]" class="active-link absolute w-full border-t-2 bottom-0 -translate-x-[102%] group-hover:translate-x-0 transition-transform duration-300"></div>
          </button>
        </div>
      </div>
      <button
        aria-label="menu"
        @click="toggleShowSidebar"
        :class="[
          { 'text-white': !scrolled && route.name === `index` },
          { 'text-ip-color-3': scrolled && route.name === `index` },
          { 'text-ip-color-3': route.name !== `index` }
        ]"
        class="lg:hidden"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
    </nav>
  </div>
</template>

<script setup>
 
const route = useRoute();
const router = useRouter();
 
const locale = ref('en')
const navbarStore = useNavbarStore();
 
const { showNavbar } = storeToRefs(navbarStore);
const showLang = ref(false);
const localeDrop = ref();
const kategori = ref();
const beritaMedia = ref();
const navMenus = ref([
  {
    path: 'index',
    sort: 0,
    visible: true,
    name: {
      id: 'Home',
      en: 'Home',
    },
    type: 'link',
  },
  {
    path: 'about-us',
    sort: 1,
    visible: true,
    name: {
      id: 'About Us',
      en: 'About Us',
    },
    type: 'link',
  },
  {
    path: 'our-services',
    sort: 2,
    visible: true,
    name: {
      id: 'Our Services',
      en: 'Our Services',
    },
    type: 'link',
  },
  {
    path: 'insights',
    sort: 3,
    visible: true,
    name: {
      id: 'Insights',
      en: 'Insights',
    },
    type: 'link',
  },
  {
    path: 'contact-us',
    sort: 4,
    visible: true,
    name: {
      id: 'Contact Us',
      en: 'Contact Us',
    },
    type: 'button',
    function: () => {
      navbarStore.toggleContact();
    },
  },
]);

const toggleShowSidebar = async () => {
  navbarStore.toggleSidebar();
};

const scrolled = ref();
const scrollHandler = (e) => {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    scrolled.value = true;
    navbarStore.scrolledActive();
  } else {
    scrolled.value = false;
    navbarStore.scrolledDisable();
  }
};
onMounted(() => {
  window.onscroll = scrollHandler;

  nextTick(() => {
    onClickOutside(kategori, () => {
      navMenus.value[1].openDropdown = false;
    });
    onClickOutside(beritaMedia, () => {
      navMenus.value[2].openDropdown = false;
    });
  });
});

onClickOutside(localeDrop, () => { showLang.value = false; });

watch(() => router.currentRoute.value,
  val => {
    navbarStore.showNavbarValue();
  },
  { immediate: true },
);
</script>

<style lang="scss" scoped>
.router-link-exact-active{
  @apply font-semibold #{!important};
  .active-link{
    @apply translate-x-0 #{!important};
  }
}
</style>
